import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Title from 'components/Title';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import TitledComponent from 'components/TitledComponent';
import Select from 'components/Select';
import selectItems from './constants/procedureType.values'
import buyerTypes from './constants/buyerType.values'
import TextInput from 'components/TextInput';
import getObjectValue from "libs/getObjectValue";
import HelpComponent from "components/HelpComponent";

const style = theme => ({
    root: {
        '&>*:not(:first-child)': {
            marginTop: theme.spacing(2),
        }
    }
})

function ProcedureSection({
                              classes,
                              formikProps,
                              idPrefix,
                              onBuyerTypeChanged
                          }) {

    const show = (tr, text) => {
        return <TitledComponent title={Tr(tr)}>
            <Typography variant='body2'>
                {text}
            </Typography>
        </TitledComponent>
    }

    return (
        <GridBlock
            column
            className={classes.root}
        >
            <Title align='center'>
                {Tr('procedure')}
            </Title>
            <HelpComponent text={<div> {Tr('tooltip_espd_buyer_type_1')}<br/>{Tr('tooltip_espd_buyer_type_2')}</div>}>
                <TitledComponent title={Tr('espd_buyer_type')}>
                    <Select
                        id={`${idPrefix}.espdBuyerType`}
                        formikProps={formikProps}
                        items={buyerTypes}
                        onChange={onBuyerTypeChanged}
                    />
                </TitledComponent>
            </HelpComponent>
            {show('title', getObjectValue(`${idPrefix}.name`, formikProps.values))}
            {show('description', getObjectValue(`${idPrefix}.description`, formikProps.values))}
            {show('reference_number', getObjectValue(`${idPrefix}.number`, formikProps.values))}
            {show('official_name', getObjectValue(`${idPrefix}.orgName`, formikProps.values))}
            {show('state', getObjectValue(`${idPrefix}.orgCountry`, formikProps.values))}
            <TitledComponent title={Tr('procedure_type')}>
                <Select
                    id={`${idPrefix}.procedureType`}
                    formikProps={formikProps}
                    items={selectItems}
                />
            </TitledComponent>
            <TitledComponent title={Tr('number_of_ad')}>
                <TextInput
                    id={`${idPrefix}.noticeReferenceNumber`}
                    formikProps={formikProps}
                    placeholder={Tr('number_of_ad')}
                />
            </TitledComponent>
        </GridBlock>
    )
}

ProcedureSection.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(ProcedureSection);
